import React from 'react';
import { styled } from '@this/constants/themes';
import type Transit from '@this/src/domain/transit/transit';
import type { LegSummaryJson } from '@this/src/domain/select_repository';
import type SegmentClass from '@this/src/domain/transit/segment';
import SelectTransportBoxRightInListTemplate from '../../right/right_in_list.template';
import SelectTransportBoxRightInDomesticAirListTemplate from '../../right/right_in_domestic_air_list.template';
import IndividualRouteInfo from './IndividualRouteInfo';

interface IndividualListProps {
  transport: Transit;
  selected: boolean;
  domesticAirPriceIndex: number;
  loading: boolean;
  handleDomesticAirPriceChange: (index: number) => void;
  handleChange: () => void;
  segment: SegmentClass;
  segmentIdx: number;
}

const IndividualList = ({
  transport,
  selected,
  domesticAirPriceIndex,
  loading, // これっている?常にこのコンポーネント内でlogは固定値falseになっている。もっと上の方で分岐あるんじゃない？
  handleDomesticAirPriceChange,
  handleChange,
  segment,
  segmentIdx
}: IndividualListProps) => {
  const renderLegSummary = (legSummary: LegSummaryJson, j: number) => {
    const isTrainOrFlight = legSummary.type === 'jr' || legSummary.type === 'air';

    if (isTrainOrFlight === false) {
      return <React.Fragment key={`empty_${segmentIdx}_${j}`} />;
    }

    return (
      <StyledLegSummaryItem key={`express_short_distance_${segmentIdx}_${j}`}>
        <IndividualRouteInfo legSummary={legSummary} segment={segment} isTrainOrFlight />
        <div className="select-transport-box__right-wrapper-shortdistance">{renderListViewPriceOptions()}</div>
      </StyledLegSummaryItem>
    );
  };

  // MEMO: この関数で使用されているコンポーネントは 旧版(short distanceではないもの)のコンポーネントを使用している。
  // short distance用のコンポーネントを新規定義することを推奨。
  const renderListViewPriceOptions = () => {
    if (transport.airExists()) {
      return (
        <StyledAirPriceOptionsPanel>
          {transport.prices?.map((p, index) => (
            <StyledTransportOptionButton
              type="button"
              key={`${transport.id}-${index}`}
              onClick={() => handleDomesticAirPriceChange(index)}
              className="transport-option-button"
              aria-pressed={
                selected &&
                transport.pricesOriginal != null &&
                p === transport.pricesOriginal[domesticAirPriceIndex]
              }
            >
              <SelectTransportBoxRightInDomesticAirListTemplate
                key={`${transport.id}-${index}`}
                loading={loading}
                selected={
                  selected &&
                  transport.pricesOriginal != null &&
                  p === transport.pricesOriginal[domesticAirPriceIndex]
                }
                price={p}
              />
            </StyledTransportOptionButton>
          ))}
        </StyledAirPriceOptionsPanel>
      );
    }

    return (
      <SelectTransportBoxRightInListTemplate
        loading={loading}
        selected={selected}
        hovered={transport.hovered}
        price={transport.price}
        isDomestic
        onClick={handleChange}
        onTouchStart={transport.handleTouched}
        onMouseOver={transport.setHovered(true)}
        onMouseLeave={transport.setHovered(false)}
      />
    );
  };

  return (
    <StyledLegSummariesContainer>
      {segment.leg_summaries.map((legSummary, j) => renderLegSummary(legSummary, j))}
    </StyledLegSummariesContainer>
  );
};

const StyledLegSummaryItem = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  &:first-child {
    padding-top: 5px;
  }
  &:last-child {
    padding-bottom: 5px;
  }
`;

const StyledLegSummariesContainer = styled.div`
  flex-shrink: 10;
  padding: 0;
  width: 100%;
`;

const StyledAirPriceOptionsPanel = styled.div`
  display: block;
  margin-left: auto;
  min-width: 242px;
  background: #f8f6f1;
  padding: 12px;
`;

const StyledTransportOptionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: pointer;
  display: block;
  &:hover {
    background: none !important;
  }
`;

export default IndividualList;
